
import React from 'react';

interface MathComponentProps {
  value: string;
  inline?: boolean;
}

export const MathComponent: React.FC<MathComponentProps> = ({ value, inline }) => {
  const renderMath = (math: string) => {
    return math
      .replace(/\\\(/g, '(')
      .replace(/\\\)/g, ')')
      .replace(/\\\[/g, '[')
      .replace(/\\\]/g, ']')
      .replace(/\\frac\{([^}]+)\}\{([^}]+)\}/g, '($1)/($2)')
      .replace(/\\sum/g, '∑')
      .replace(/\\int/g, '∫')
      .replace(/\\alpha/g, 'α')
      .replace(/\\beta/g, 'β')
      .replace(/\\gamma/g, 'γ')
      .replace(/\\delta/g, 'δ')
      .replace(/\\pi/g, 'π')
      .replace(/\\theta/g, 'θ')
      .replace(/\\lambda/g, 'λ')
      .replace(/\\mu/g, 'μ')
      .replace(/\\sigma/g, 'σ')
      .replace(/\\phi/g, 'φ')
      .replace(/\\omega/g, 'ω');
  };

  if (inline) {
    return (
      <span className="inline-flex items-center px-2 py-1 bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-300 rounded text-xs font-mono border border-blue-200 dark:border-blue-800">
        {renderMath(value)}
      </span>
    );
  }

  return (
    <div className="my-3 p-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
      <div className="text-blue-700 dark:text-blue-300 font-mono text-center text-xs">
        {renderMath(value)}
      </div>
    </div>
  );
};
